/*
 * Boop & Bean: header dropdown grace period.
 *
 * Horizon closes a dropdown (and makes it unclickable) the instant the pointer
 * leaves its top-level menu item, so moving the mouse down into the dropdown
 * often closes it before the shopper can click. This holds the "leave" for a
 * short moment and only lets it through if the pointer has not come back to
 * the item or its dropdown. Runs on window capture, ahead of the theme's own
 * document-level listener in component.js.
 */
(function () {
  var DELAY_MS = 400;
  var timers = new WeakMap();
  var PASS = '__bbMenuGracePass';

  function isMenuItem(el) {
    return el instanceof HTMLElement && el.classList.contains('menu-list__list-item') && el.hasAttribute('on:pointerleave');
  }

  function clear(li) {
    var t = timers.get(li);
    if (t) {
      clearTimeout(t);
      timers.delete(li);
    }
  }

  window.addEventListener(
    'pointerleave',
    function (event) {
      var li = event.target;
      if (!isMenuItem(li) || event[PASS] || event.pointerType === 'touch') return;

      event.stopImmediatePropagation();
      clear(li);
      timers.set(
        li,
        setTimeout(function () {
          timers.delete(li);
          // Pointer is back on the item or inside its dropdown: keep it open.
          if (li.matches(':hover')) return;
          // Only close the item that is still the open one.
          if (!li.querySelector('[aria-expanded="true"]')) return;
          var ev = new PointerEvent('pointerleave', { bubbles: false, relatedTarget: null });
          ev[PASS] = true;
          li.dispatchEvent(ev);
        }, DELAY_MS)
      );
    },
    true
  );

  window.addEventListener(
    'pointerenter',
    function (event) {
      if (isMenuItem(event.target)) clear(event.target);
    },
    true
  );
})();